import { BRAND_ROLES, deriveColorTokens, roleVariable, type ColorTokens } from "@web-ui/brand/color-tokens";
import { brandGround } from "@web-ui/styles/grounds";

/**
 * The selected brand's colour roles over the kit's tokens (the same derivation the portal and the
 * apps use), so the console wears the brand being edited: a quiet reminder of which one it is.
 */
export function applyBrandColors(accent: string): void {
  const vars = (t: ColorTokens) => BRAND_ROLES.map((role) => `${roleVariable(role)}:${t[role]};`).join("");
  const light = deriveColorTokens({ accent }, brandGround.light);
  const dark = deriveColorTokens({ accent }, brandGround.dark);
  let style = document.getElementById("brand-colors");
  if (!style) {
    style = document.createElement("style");
    style.id = "brand-colors";
    document.head.appendChild(style);
  }
  style.textContent = `html:root{${vars(light)}}html[data-theme="dark"],html [data-theme="dark"]{${vars(dark)}}`;
}

/** Another brand's mark colours (the switcher lists every brand): its accent fill and the ink on it. */
export function brandMarkColors(accent: string): { fill: string; ink: string } {
  const t = deriveColorTokens({ accent }, brandGround.light);
  return { fill: t.accent, ink: t.onAccent };
}
